import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const Stepper = ( { totalSteps, currentStep, setCurrentStep, variant } ) => {

  const handleClick = step => {
    if (step < currentStep) {
      setCurrentStep(step)
    }
  }

  const currentStepColor = variant === 'warstic' ? '#B29E6A' : `#48435C`;
  const completedStepColor = variant === 'warstic' ? 'black' : 'var(--red)';

  return (
    <StyledStepperContainer>
      <StepLine />
      <StepLineCompleted
        initial={{ width: 0}}
        animate={{ width: `${currentStep / ( totalSteps - 1 ) * 100}%` }}
        transition={{ duration: .5}}
      />
      {[...Array( totalSteps )].map( ( _, i ) => (
        <Step
          key={i}
          onClick={() => handleClick( i )}
          initial={{
            backgroundColor: '#fff',
            boxShadow: '0px 5px 20px 0 #333',
            borderColor: '#fff'
          }}
          animate={{
            backgroundColor: i === currentStep ? currentStepColor : i < currentStep ? completedStepColor : '#ccc',
            boxShadow: i < currentStep ? '0px 5px 20px -15px #33333300' : '0px 5px 20px 0 #333',
            borderColor: i < currentStep ? completedStepColor : '#fff'
          }}
          transition={{ delay: .3 }}
          style={{ cursor: i < currentStep ? 'pointer' : 'default' }}
        >
          {i < currentStep ? (
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve" width="26px" height="26px"><polygon points="89.71,28.73 80.79,19.82 38.25,62.36 19.21,43.32 10.29,52.23 38.25,80.18 " /></svg>
          ) : i + 1}
        </Step>
      ) )}
    </StyledStepperContainer>

  )
}

const StyledStepperContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 0 20px;

  @media (max-width: 500px) {
    width: 100%;
  }
`

const StepLine = styled.div`
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: #fff;
  pointer-events: none;
`

const StepLineCompleted = styled(motion.div)`
  position: absolute;
  width: 0;
  height: 3px;
  background-color: #48435C;
  pointer-events: none;
`

const Step = styled(motion.div)`
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-weight: bold;
  font-size: 1.5rem;
  color: #fff;
  background-color: #fff;
  box-shadow: 0px 5px 20px 0 #333;
  fill: #fff;


  @media (max-width: 990px) {
    width: 40px;
    font-size: 1.2rem;
  }

  @media (max-width: 767px) {
    width: 30px;
  }

`

export default Stepper